import { SITE } from '@config/constants';

export default function ContactPage() {
  return (
    <section className="py-16">
      <div className="max-w-3xl mx-auto px-5">
        <div className="text-center mb-12">
          <h1 className="section-title text-4xl">Contact Us</h1>
          <div className="section-divider" />
          <p className="text-white/50 mt-3">We'd love to hear from you</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="card-admin p-8">
            {[
              { icon: '📍', label: 'Address', value: SITE.address },
              { icon: '📞', label: 'Phone', value: SITE.phone },
              { icon: '✉️', label: 'Email', value: SITE.email },
              { icon: '🕐', label: 'Hours', value: SITE.hours },
            ].map((c, i) => (
              <div key={i} className={`flex gap-4 py-3.5 ${i < 3 ? 'border-b border-gold-500/[0.06]' : ''}`}>
                <span className="text-xl">{c.icon}</span>
                <div>
                  <div className="text-[11px] text-white/40 tracking-wider mb-1">{c.label}</div>
                  <div className="text-sm text-temple-cream whitespace-pre-line">{c.value}</div>
                </div>
              </div>
            ))}
          </div>
          <div className="card-admin p-8 space-y-4">
            <div>
              <label className="input-label">Name</label>
              <input className="input-field" placeholder="Your name" />
            </div>
            <div>
              <label className="input-label">Email</label>
              <input className="input-field" type="email" placeholder="your@email.com" />
            </div>
            <div>
              <label className="input-label">Message</label>
              <textarea className="input-field h-24 resize-none" placeholder="How can we help you?" />
            </div>
            <button className="btn-primary w-full">Send Message</button>
          </div>
        </div>
      </div>
    </section>
  );
}
